import { useMutation } from '@tanstack/react-query';
import { UserWalletCompanyInfoService } from 'services/openapi';

type RemoveCompMutationVariables = {
  compID: string;
};

export const useRemoveCompMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, RemoveCompMutationVariables>({
      mutationFn: (variables: RemoveCompMutationVariables) => {
        return UserWalletCompanyInfoService.companyControllerDeleteComp(
          variables.compID,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
